module.exports = __webpack_public_path__ + "static/media/btn_hide_on.dbb27b35.png";